import { Input as AntdInput } from 'antd';
import styled from 'styled-components';

const Input = styled(AntdInput)`
    border-radius: 25px;
    font-size: var(--input-font-size, 1rem);
    height: 48px;
    color: var(--ant-primary-color);
    padding: 11px 18px;
    background: #f0f0f0;

    ::placeholder {
        /* Chrome, Firefox, Opera, Safari 10.1+ */
        color: #000;
        opacity: 0.5; /* Firefox */
    }

    :-ms-input-placeholder {
        /* Internet Explorer 10-11 */
        color: #000;
        opacity: 0.5;
    }

    ::-ms-input-placeholder {
        /* Microsoft Edge */
        color: #000;
        opacity: 0.5;
    }

    & .ant-input-group-addon {
        background: #f0f0f0;
        border: unset;
    }
`;

export default Input;
